import { render, staticRenderFns } from "./FeedbackProductType.vue?vue&type=template&id=4f75577e&"
import script from "./FeedbackProductType.vue?vue&type=script&lang=js&"
export * from "./FeedbackProductType.vue?vue&type=script&lang=js&"
import style0 from "./FeedbackProductType.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports